// 页面的类型
import {
    TextAreaType,
    TextLeafNode,
} from '@src/slide/application/service/slide-content-layout-analyzer/core/algorithm/data-structure/text-leaf-node';
import { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';

export enum PageType {
    // 封面页或称之为标题页
    CoverPage = 'CoverPage',
    // 目录页
    TableOfContents = 'TableOfContents',
    // 分隔页，如目录对应的主题页，后面常跟着主题内容
    SectionDivider = 'SectionDivider',
    // 致谢页
    Acknowledgments = 'Acknowledgments',
    // 正文页面，可能有标题，可能没有标题
    Content = 'Content',
}

/**
 * 页面的文本信息
 */
export class PageText {
    // 页面数据模型
    public pageModel: ISlideModel;
    // 页面类型
    public pageType: PageType = PageType.Content;
    // 文字信息
    public texts: TextLeafNode[];
    private allTextString: string;

    public constructor(pageModel: ISlideModel, texts: TextLeafNode[], pageType?: PageType) {
        this.pageModel = pageModel;

        this.texts = texts;

        if (pageType) {
            this.pageType = pageType;
        }
    }

    public getAllTextString(): string {
        if (this.allTextString) return this.allTextString;
        this.allTextString =  this.texts.map(text => text.text).join('');
        return this.allTextString;
    }

    // 如果推测出来是封面页，则重置封面页标题
    public resetCoverPageTitle() {
        if (this.pageType !== PageType.CoverPage) return;
        // 找到字体最大的文字，设置为标题
        const maxFontSize = this.texts.reduce((max, text) => {
            const fontSize = text.contentBlock.getTextFontSize();
            if (fontSize > max) return fontSize;
            return max;
        }, 0);
        this.texts.forEach((node) => {
            const fontSize = node.contentBlock.getTextFontSize();
            if (fontSize === maxFontSize) {
                node.titleOrContent = TextAreaType.Title;
            } else {
                node.titleOrContent = TextAreaType.Content;
            }
        });
    }
}
